// 文件上传地址
export const UPLOADURL = "https://dyh-class.obs.cn-north-4.myhuaweicloud.com";
export const DOMAIN = "https://dyh-class.obs.cn-north-4.myhuaweicloud.com";

// 分页数组
export const pageSizes = [
  10, 20, 30, 40, 50, 60, 70, 80, 90, 100, 150, 200, 250, 300,
];

// 分页显示元素
export const pageLayout = "total, sizes, prev, pager, next, jumper"

// 权限菜单 path  和  component 进行映射
export const RouterPathComponent = {
  applicationSquare: () =>
    import("@/views/applicationSquare/ApplicationSquare.vue"), // 应用中心
  chat: () => import("@/views/ChatPlus.vue"), // AI对话
  aiChangeClothes: () => import("@/views/AiChangeClothes/index.vue"), // AI换装
  digitalHumanFront: () =>
    import("@/views/digitalHuman/digitalHumanResult.vue"), // 数字人
  liveStreamingScene: () => import("@/views/liveStreamingScene/index.vue"), // 直播场景
  documentChange: () => import("@/views/DocumentChange.vue"), // 文档转换
  textGeneratedImages: () =>
    import("@/views/textGeneratedImages/textGeneratedImages.vue"), // 文本生成图片
  tiktokTalent: () => import("@/views/tiktokTalent/tiktokTalent.vue"), // 抖音达人
  theDigitalHumanNew: () =>
    import("@/views/theDigitalHumanNew/theDigitalHumanNew.vue"), // 新的数字人
  speechSynthesis: () => import("@/views/speechSynthesis/speechSynthesis.vue"), // 语音合成
  personalCenter: () => import("@/views/personalCenter/personalCenter.vue"), // 个人中心
  knowledgeBase: () => import("@/views/knowledgeBase/knowledgeBase.vue"), // 知识库
  "webgl-list": () => import("@/views/webGlManager/list.vue"), // VR场景
  "soundCloning-list": () =>
    import("@/views/soundCloning/soundCloningList.vue"), // 声音克隆
  "speechRecognition-list": () => import("@/views/speechRecognition/speechRecognition.vue"), // 语音识别
  imageGenerator: () => import("@/views/imageGenerator/index.vue"), // 图片生成器
  digitalHumanSynthesis: () => import("@/views/digitalHumanSynthesis/index.vue"), // 数字人合成
  // modelHandle: () => import("@/views/modelHandle/indexPage.vue"), // 模型压缩
};
